// extracted by mini-css-extract-plugin
export var badge = "_gx-2";
export var detailsPanel = "_gx-0";
export var resultRow = "_gx-1";